import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function IdPhotoPrivacyPolicyKo() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 개인정보 처리방침

"증명사진어플 - 여권사진" (이하 "본 앱"이라 함)는 사용자의 프라이버시를 존중하며 개인정보 보호에 최선을 다하고 있습니다. 본 앱은 사용자의 개인정보를 수집하지 않으며, 사용자 데이터를 보호하기 위한 조치를 취하고 있습니다. 본 개인정보 처리방침(이하 "본 방침"이라 함)은 본 앱에서의 정보 처리에 대해 규정합니다.

## 제1조 (개인정보 수집 및 관리 방침)

본 앱은 사용자로부터 어떠한 개인정보(이름, 주소, 전화번호 등)도 수집하지 않습니다. 앱 내의 모든 기능은 개인정보를 수집하지 않는다는 전제하에 설계되었습니다. 또한, 사용자의 프라이버시 보호를 위해 개인을 식별할 수 있는 정보의 수집이나 저장은 일절 하지 않습니다.

## 제2조 (사용자 데이터 저장)

본 앱에서는 사용자가 스캔한 모든 결과가 사용자의 기기 내에만 저장되며, 앱 외부 서버 등에 저장되지 않습니다. 따라서 사용자가 스캔한 데이터에 대해 본 앱 및 개발사는 일절 접근하지 않습니다. 또한, 이러한 데이터는 제3자에게 제공되지 않으며, 사용자의 기기 내에서 안전하게 보관됨을 보장합니다.

## 제3조 (광고 게재)

본 앱은 Google AdMob을 통해 광고를 게재합니다. 광고 게재 과정에서 Google이 제공하는 시스템에 의해 광고 최적화를 위한 데이터가 자동으로 수집될 수 있으나, 이러한 데이터는 Google의 개인정보 처리방침에 따라 관리됩니다. 본 앱은 광고 게재와 관련된 개인정보를 일절 보유하지 않습니다. 자세한 내용은 Google의 개인정보 처리방침을 참조하시기 바랍니다.

## 제4조 (사용자 권리와 데이터 관리)

본 앱은 사용자가 자신의 데이터를 완전히 통제할 수 있도록 보장합니다. 사용자는 언제든지 앱 내의 데이터를 삭제할 수 있으며, 본 앱은 사용자의 조작 없이는 데이터를 외부로 전송하지 않습니다. 또한, 이용약관에 따라 본 앱 사용 시 개인정보를 사용하지 않으므로, 정보의 공개, 정정, 삭제, 이용 중지에 관한 요청은 해당되지 않습니다.

## 제5조 (개인정보 처리방침의 변경)

본 앱은 본 방침의 내용을 수시로 검토하고, 사용자의 프라이버시 보호 향상을 위해 법령의 개정이나 앱 기능의 변경 등에 따라 본 방침을 변경할 수 있습니다. 변경이 있을 경우, 최신 개인정보 처리방침을 본 앱 내에 게시함으로써 사용자에게 통지하며, 게시와 동시에 효력이 발생합니다. 사용자는 정기적으로 본 방침을 확인해 주시기 바랍니다.

## 제6조 (문의처)

본 방침에 관한 문의나 불명확한 점이 있으시면 아래 연락처로 문의해 주시기 바랍니다.

이메일 주소: linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default IdPhotoPrivacyPolicyKo; 
